import { createPortal } from 'react-dom';

import { cn } from '@virginexperiencedays/tailwind';
import { useScrollLock } from '@virginexperiencedays/hooks';

import { Modal } from '@virginexperiencedays/components-v2/src/layout/Modal';
import { SectionHeading } from '@virginexperiencedays/components-v2/src/typography/SectionHeading';

import type { ReactNode } from 'react';

export const ReviewsModal = ({
  open,
  setOpen,
  title,
  children,
  className,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  title: string;
  children: ReactNode;
  className?: string;
}) => {
  useScrollLock(open);

  // For portal to work properly it needs to be rendered on CSR
  // So it has to be rendered conditionally triggered on a local state ideally
  // like open && <Modal> ...
  return createPortal(
    <Modal
      isOpen={open}
      hideModal={() => {
        setOpen(false);
      }}
      outerClassName="md:flex [@media(max-height:600px)]:block"
      className={cn(
        'max-w-[780px] [&_[data-testid="modal-close-icon"]]:right-4 [&_[data-testid="modal-close-icon"]]:top-3',
        className
      )}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalContent>{children}</ModalContent>
    </Modal>,
    document.body
  );
};

export const ModalHeader = ({ children }: { children: ReactNode }) => (
  <div className="px-8 pb-0 pt-6">
    <SectionHeading className="text-2xl leading-tight">{children}</SectionHeading>
  </div>
);

export const ModalContent = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-col px-8 py-6">{children}</div>
);
